import React from 'react'

import {
  ArrowSvg,
  EyeCloseSvg,
  EyeSvg,
  LoadingSvg,
} from '@components/adgroup-svg/react'
import ButtonDiv from '@components/button-div/ButtonDiv'

import { ApartmentRoute, HouseAndLandRoute } from '@adUtilities/types'

interface InteractiveMapLayerProps {
  label?: string
  isActive?: boolean
  isValid?: boolean
  route?: ApartmentRoute | HouseAndLandRoute
  as?: 'a' | 'button'
  isProcessing?: boolean
  onClick: () => void
  onClickLink: React.MouseEventHandler
}

function InteractiveMapLayer({
  label,
  isActive,
  isValid,
  route,
  as: Tag = 'a',
  isProcessing,
  onClick,
  onClickLink,
}: InteractiveMapLayerProps) {
  const isButton = Tag === 'button'

  return (
    <ButtonDiv
      className={`flex cursor-pointer items-center justify-between rounded-lg bg-secondaryColour p-5 text-mainColour transition-all duration-300 ${
        isActive ? 'border-l-8 border-mainColour' : ''
      }`}
      ariaLabel={label}
      onClick={onClick}
    >
      {isValid ? (
        <Tag
          href={!isButton ? route : undefined}
          type={isButton ? 'button' : undefined}
          onClick={onClickLink}
        >
          <span className="border-b-2 border-mainColour text-default font-medium">
            {label}
          </span>
          <span
            className={`text-default font-medium ${isProcessing ? 'pl-2' : 'border-b-2 border-mainColour'}`}
          >
            {isProcessing ? (
              <LoadingSvg className="inline-block h-7 w-7 fill-white" />
            ) : (
              <ArrowSvg
                size="m"
                className="-mr-2.5 inline-block h-10 w-10 stroke-mainColour"
                styles={{ rotate: '135deg' }}
              />
            )}
          </span>
        </Tag>
      ) : (
        <h2 className="text-default font-medium">{label}</h2>
      )}
      <span
        className={`rounded-full ${
          isActive ? 'bg-mainColour' : 'bg-neutralColour'
        } px-2 py-2 transition-all duration-300`}
      >
        {isActive ? (
          <EyeCloseSvg className="h-7 w-7 text-neutralColour" />
        ) : (
          <EyeSvg className="h-7 w-7 text-mainColour" />
        )}
      </span>
    </ButtonDiv>
  )
}

export default InteractiveMapLayer
